import { render, staticRenderFns } from "./new_title.vue?vue&type=template&id=7e7ec4f2&scoped=true&"
import script from "./new_title.vue?vue&type=script&lang=js&"
export * from "./new_title.vue?vue&type=script&lang=js&"
import style0 from "./new_title.vue?vue&type=style&index=0&id=7e7ec4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7ec4f2",
  null
  
)

export default component.exports